import { ref } from 'vue'

export const MOBILE_BREAKPOINT = 768

const isWide = ref(window.innerWidth >= MOBILE_BREAKPOINT)
const viewportWidth = ref(window.innerWidth)

let listenerAttached = false
let refCount = 0

function handleResize() {
  isWide.value = window.innerWidth >= MOBILE_BREAKPOINT
  viewportWidth.value = window.innerWidth
}

export function useViewport() {
  refCount++
  if (!listenerAttached) {
    window.addEventListener('resize', handleResize)
    listenerAttached = true
  }
  const release = () => {
    refCount--
    if (refCount <= 0 && listenerAttached) {
      window.removeEventListener('resize', handleResize)
      listenerAttached = false
    }
  }
  return { isWide, viewportWidth, release }
}
